import { Center, Overlay } from '@phx/design-system';

export const Loader = () => {
    return (
        <Center>
            <Overlay loader fullScreen visible />
        </Center>
    );
};
